(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("systemsApi", [], factory);
	else if(typeof exports === 'object')
		exports["systemsApi"] = factory();
	else
		root["systemsApi"] = factory();
})(self, () => {
return 